import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: string;
  onReportError?: (() => void) | undefined;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--color-error)' }}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page to try again.</p>
          <div style={{ display: 'flex', gap: 'var(--space-2)', justifyContent: 'center' }}>
            <button
              className="btn btn-primary"
              onClick={() => this.setState({ hasError: false })}
            >
              Try Again
            </button>
            {this.props.onReportError && (
              <button
                className="btn"
                onClick={this.props.onReportError}
              >
                Report this error
              </button>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
